import { createEvent } from "effector";
const OnChangeCurrentPageEvt = () => {
    const onChangeCurrentPageEvt = createEvent("OnChangeCurrentPageEvt");
    onChangeCurrentPageEvt.watch(() => console.log("OnChangeCurrentPageEvt"));
    return onChangeCurrentPageEvt;
};
export default OnChangeCurrentPageEvt;
//# sourceMappingURL=OnChangeCurrentPageEvt.js.map